import { IconButton, Stack, Tooltip } from '@mui/material';
import { SharedReaderToolbarVariantProps } from '.';
import { getTabPanelId } from '../menuTabUtils';
import { useTranslation } from 'react-i18next';

export default function ReaderToolbarHorizontal({
  activeId,
  onItemClick,
  items,
}: Readonly<SharedReaderToolbarVariantProps>) {
  const { t } = useTranslation();

  return (
    <Stack
      component='ul'
      role='menubar'
      aria-orientation='vertical'
      aria-label='Document menu'
      sx={{
        margin: 0,
        padding: 0,
        display: { xs: 'flex', lg: 'none' },
        flexDirection: 'row',
      }}
    >
      {items.map((item) => {
        const isActive = activeId === item.id;

        return (
          <Stack
            key={item.id}
            component='li'
            role='none'
            sx={{ listStyleType: 'none' }}
          >
            <Tooltip title={t(item.labelKey)} placement='bottom'>
              <IconButton
                role='menuitem'
                id={`sidebar-item-${item.id}`}
                onClick={() => onItemClick(item.id)}
                aria-label={t(item.labelKey)}
                aria-expanded={isActive}
                aria-controls={isActive ? getTabPanelId(item) : undefined}
                sx={{
                  color: (theme) =>
                    isActive ? theme.palette.text.primary : 'default',
                  justifyContent: 'center',
                  minHeight: 40,
                  padding: 1,
                  ...(isActive && {
                    backgroundColor: (theme) => {
                      return theme.palette.primary.main + '14'; // '14' is hex value for 8% opacity
                    },
                  }),
                }}
              >
                {item.icon}
              </IconButton>
            </Tooltip>
          </Stack>
        );
      })}
    </Stack>
  );
}
